// Tati Rosales. Cabecera, menú, stickers que se arrastran, galería, cantidad y formulario.
(() => {
  const raiz = document.documentElement;
  raiz.classList.remove("sin-js");
  const quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Stickers de la portada después de la foto principal. Con señal débil competían con ella y la foto
  // tardaba en aparecer (17-10). Se sueltan cuando la foto termina de cargar o falla
  const diferidos = document.querySelectorAll("img[data-diferido-src]");
  if (diferidos.length) {
    let suelto = false;
    const soltar = () => {
      if (suelto) return;
      suelto = true;
      diferidos.forEach((img) => {
        if (img.dataset.diferidoSrcset) {
          img.sizes = img.dataset.diferidoSizes || "";
          img.srcset = img.dataset.diferidoSrcset;
        }
        img.src = img.dataset.diferidoSrc;
      });
    };
    const foto = document.querySelector("img[fetchpriority='high']");
    if (!foto || foto.complete) soltar();
    else {
      foto.addEventListener("load", soltar, { once: true });
      foto.addEventListener("error", soltar, { once: true });
    }
  }

  // Cabecera que se esconde al bajar y vuelve al subir
  const cabecera = document.querySelector("[data-cabecera]");
  if (cabecera) {
    let ultimo = window.scrollY;
    let pendiente = false;
    const revisar = () => {
      const y = window.scrollY;
      cabecera.classList.toggle("flotando", y > 16);
      const bajando = y > ultimo && y > 240;
      cabecera.classList.toggle("escondida", bajando && !document.body.classList.contains("menu-abierto"));
      ultimo = y;
      pendiente = false;
    };
    window.addEventListener("scroll", () => {
      if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
    }, { passive: true });
    revisar();
  }

  // Menú del teléfono
  const menu = document.getElementById("menu-movil");
  const abrir = document.querySelector("[data-abrir-menu]");
  if (menu && abrir) {
    const cerrarBoton = menu.querySelector("[data-cerrar-menu]");
    const cambiar = (abierto) => {
      menu.classList.toggle("abierto", abierto);
      menu.setAttribute("aria-hidden", String(!abierto));
      abrir.setAttribute("aria-expanded", String(abierto));
      document.body.classList.toggle("menu-abierto", abierto);
      document.body.style.overflow = abierto ? "hidden" : "";
      if (abierto) { setTimeout(() => cerrarBoton && cerrarBoton.focus(), 60); } else { abrir.focus(); }
    };
    abrir.addEventListener("click", () => cambiar(true));
    cerrarBoton && cerrarBoton.addEventListener("click", () => cambiar(false));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && menu.classList.contains("abierto")) cambiar(false); });
    menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => cambiar(false)));
  }

  // Aparecer al hacer scroll
  const revelables = document.querySelectorAll(".revelar");
  if ("IntersectionObserver" in window && !quieto) {
    const obs = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("visto"); obs.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    revelables.forEach((el) => obs.observe(el));
  } else {
    revelables.forEach((el) => el.classList.add("visto"));
  }

  // Stickers que se pueden mover, solo con mouse. En el teléfono el dedo tiene que deslizar la página
  const conMouse = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (conMouse) document.querySelectorAll("[data-arrastrable]").forEach((st) => {
    let inicio = null;
    let base = { x: 0, y: 0 };
    st.addEventListener("pointerdown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      st.setPointerCapture(e.pointerId);
      st.classList.remove("flotar", "flotar--2", "flotar--3");
      st.classList.add("arrastrando");
      inicio = { x: e.clientX, y: e.clientY };
    });
    st.addEventListener("pointermove", (e) => {
      if (!inicio) return;
      const x = base.x + e.clientX - inicio.x;
      const y = base.y + e.clientY - inicio.y;
      st.style.translate = `${x}px ${y}px`;
    });
    const soltar = (e) => {
      if (!inicio) return;
      base = { x: base.x + e.clientX - inicio.x, y: base.y + e.clientY - inicio.y };
      inicio = null;
      st.classList.remove("arrastrando");
    };
    st.addEventListener("pointerup", soltar);
    st.addEventListener("pointercancel", soltar);
    st.addEventListener("dblclick", () => { base = { x: 0, y: 0 }; st.style.translate = ""; });
  });

  // Tira de historias que se arrastra con el mouse
  document.querySelectorAll("[data-tira]").forEach((tira) => {
    let x0 = 0, s0 = 0, activo = false, movio = false;
    tira.addEventListener("pointerdown", (e) => {
      if (e.pointerType !== "mouse") return;
      activo = true; movio = false; x0 = e.clientX; s0 = tira.scrollLeft;
      tira.classList.add("arrastrando");
    });
    window.addEventListener("pointermove", (e) => {
      if (!activo) return;
      const d = e.clientX - x0;
      if (Math.abs(d) > 4) movio = true;
      tira.scrollLeft = s0 - d;
    });
    window.addEventListener("pointerup", () => {
      if (!activo) return;
      activo = false;
      tira.classList.remove("arrastrando");
    });
    tira.addEventListener("click", (e) => { if (movio) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  // Galería de producto
  document.querySelectorAll("[data-galeria]").forEach((gal) => {
    const principal = gal.querySelector("[data-principal]");
    const botones = [...gal.querySelectorAll("[data-medio]")];
    const mostrar = (b) => {
      botones.forEach((x) => x.setAttribute("aria-current", String(x === b)));
      const tipo = b.dataset.tipo;
      if (tipo === "video") {
        principal.innerHTML = `<video src="${b.dataset.src}" poster="${b.dataset.poster || ""}" controls playsinline autoplay muted></video>`;
      } else {
        principal.innerHTML = `<img src="${b.dataset.src}" srcset="${b.dataset.srcset || ""}" sizes="(max-width: 960px) 92vw, 50vw" alt="${b.dataset.alt || ""}">`;
      }
    };
    botones.forEach((b, i) => {
      b.addEventListener("click", () => mostrar(b));
      b.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          const siguiente = botones[(i + (e.key === "ArrowRight" ? 1 : botones.length - 1)) % botones.length];
          siguiente.focus();
          mostrar(siguiente);
        }
      });
    });
  });

  // Cantidad y botón de compra
  document.querySelectorAll("[data-compra]").forEach((caja) => {
    const input = caja.querySelector("input[type=number]");
    const boton = caja.querySelector("[data-comprar]");
    const actualizar = () => {
      const n = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1));
      input.value = n;
      const url = new URL(boton.href);
      url.searchParams.set("quantity", n);
      boton.href = url.toString();
    };
    caja.querySelectorAll("[data-paso]").forEach((b) => b.addEventListener("click", () => {
      input.value = (parseInt(input.value, 10) || 1) + Number(b.dataset.paso);
      actualizar();
    }));
    input.addEventListener("change", actualizar);
  });

  // Ver todas las reseñas
  document.querySelectorAll("[data-mas-resenas]").forEach((b) => {
    b.addEventListener("click", () => {
      document.querySelectorAll("[data-resena-oculta]").forEach((n) => { n.hidden = false; });
      b.closest(".mas-resenas").remove();
    });
  });

  // Compartir
  document.querySelectorAll("[data-compartir]").forEach((b) => {
    b.addEventListener("click", async () => {
      const url = b.dataset.compartir;
      if (navigator.share) {
        try { await navigator.share({ title: document.title, url }); } catch (_) { /* cancelado */ }
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        const texto = b.querySelector("span");
        const antes = texto.textContent;
        texto.textContent = "Enlace copiado";
        setTimeout(() => { texto.textContent = antes; }, 1800);
      }
    });
  });

  // Mis favoritos, filtros por categoría y buscador
  const grilla = document.querySelector("[data-grilla]");
  if (grilla) {
    const tarjetas = [...grilla.querySelectorAll(".fav")];
    const chips = [...document.querySelectorAll(".chip")];
    const buscar = document.querySelector("[data-buscar]");
    const cuenta = document.querySelector("[data-cuenta]");
    const vacio = document.querySelector("[data-sin-resultados]");
    let filtro = "todos";
    const normalizar = (t) => (t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();
    const aplicar = () => {
      const palabras = normalizar(buscar ? buscar.value : "").split(" ").filter(Boolean);
      let n = 0;
      tarjetas.forEach((t) => {
        const enCategoria = filtro === "todos" || (" " + t.dataset.categorias + " ").includes(" " + filtro + " ");
        const calza = palabras.every((p) => (t.dataset.texto || "").includes(p));
        t.hidden = !(enCategoria && calza);
        if (!t.hidden) n++;
      });
      if (cuenta) cuenta.textContent = n;
      if (vacio) vacio.hidden = n !== 0;
    };
    const elegir = (id, desdeHash) => {
      filtro = chips.some((c) => c.dataset.filtro === id) ? id : "todos";
      chips.forEach((c) => c.setAttribute("aria-pressed", String(c.dataset.filtro === filtro)));
      aplicar();
      if (!desdeHash) {
        try { history.replaceState(null, "", filtro === "todos" ? location.pathname + location.search : "#" + filtro); } catch (_) { /* sin historial */ }
      }
    };
    chips.forEach((c) => c.addEventListener("click", () => elegir(c.dataset.filtro)));
    buscar && buscar.addEventListener("input", aplicar);
    const inicial = decodeURIComponent(location.hash.slice(1));
    if (chips.some((c) => c.dataset.filtro === inicial)) {
      elegir(inicial, true);
      document.getElementById("catalogo").scrollIntoView();
    }
    window.addEventListener("hashchange", () => elegir(decodeURIComponent(location.hash.slice(1)), true));
  }

  // Video de Instagram en ventana
  const ventana = document.querySelector("[data-ventana]");
  if (ventana) {
    const contenido = ventana.querySelector("[data-ventana-contenido]");
    document.querySelectorAll("[data-reel]").forEach((b) => b.addEventListener("click", () => {
      if (!ventana.showModal) { window.open(b.dataset.reel, "_blank", "noopener"); return; }
      const url = b.dataset.reel.replace(/\/?$/, "/") + "embed/";
      contenido.innerHTML = `<iframe src="${url}" title="Video de Instagram" allow="autoplay; encrypted-media; picture-in-picture"></iframe>`;
      ventana.showModal();
    }));
    ventana.querySelector("[data-cerrar-ventana]").addEventListener("click", () => ventana.close());
    ventana.addEventListener("click", (e) => { if (e.target === ventana) ventana.close(); });
    ventana.addEventListener("close", () => { contenido.innerHTML = ""; });
  }

  // Formulario de contacto, validación antes de enviar a la tienda
  document.querySelectorAll("[data-formulario]").forEach((form) => {
    const correo = form.querySelector("input[type=email]");
    const error = form.querySelector("[data-error-correo]");
    const campo = correo && correo.closest(".campo");
    const valido = () => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(correo.value.trim());
    form.addEventListener("submit", (e) => {
      if (!correo) return;
      if (!valido()) {
        e.preventDefault();
        campo.classList.add("invalido");
        error.textContent = correo.value.trim() ? "Revisa tu correo, parece que le falta algo." : "Escribe tu correo para poder responderte.";
        correo.focus();
      }
    });
    correo && correo.addEventListener("input", () => {
      if (campo.classList.contains("invalido") && valido()) { campo.classList.remove("invalido"); error.textContent = ""; }
    });
  });
})();
